import { Button, DataSource, Layout, LayoutHeader, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutDriverList extends Layout {
    driverAdvanceButton: Button;
    layoutheaderDriverList: LayoutHeader;
    panelDriverList: Panel;
    sourceDriver: DataSource;
    tableDriver: Table;
}
